/**
 * Created by Zac on 17/05/2016.
 */
import Cookies from 'js-cookie';
import {getSuspendData} from "./scormfunctions";

$(function () {
    function select(state) {
        return state.sceneGroups;
    }

    let curSceneGroupState;

    function handleSceneChange() {
        const previousValue = curSceneGroupState;
        curSceneGroupState = select(store.getState());
        const suspendData = getSuspendData();
        if (previousValue !== curSceneGroupState) {
            if (window.DEBUGGING) console.log('Updating the scene groups');
            for (let i = 0; i < curSceneGroupState.length; i++) {
                if(window.DEBUGGING){
                    console.group('scene');
                    console.log('For scene group', curSceneGroupState[i].sceneGroupId);
                    console.log('Scene', curSceneGroupState[i].currentScene, 'is to be shown');
                    console.groupEnd('scene');
                    console.log('Suspend data on handleSCENEChange',suspendData)
                }
                const sceneId = suspendData && suspendData.resumeLocation && suspendData.resumeLocation.sceneId;
                const isElementExists = $(`[data-id="${sceneId}"]`);
                $(`[data-id="${curSceneGroupState[i].sceneGroupId}"] > .scene`).hide();
                if (curSceneGroupState[i].initiallyLoaded && sceneId && isElementExists.length > 0) {
                    $(`[data-id="${sceneId}"]`).show();
                } else {
                  const currentSceneEl = $(`[data-id="${curSceneGroupState[i].currentScene}"]`)
                  $(currentSceneEl).show()
                  const currenSceneGroupId = curSceneGroupState[i].sceneGroupId;
                  handleMuteOnSceneChange(currentSceneEl,currenSceneGroupId);
                  playCurrentSceneFirstVideo(currentSceneEl,currenSceneGroupId)
                  const isNavBlock = $(currentSceneEl).attr('data-scene');
                  if(isNavBlock=='NavigationBlock'){
                    $(window).scrollTop(0);
                  }else {
                    $(currentSceneEl).get(0).scrollIntoView();
                  }
                }

            }
        }
    }
    
    function stopAllVideoPlayers(){
      const players = $('.jwplayer');
      const videoPlayerIDs = players.map(player => $(players[player]).attr('id'));
      for (let i = 0; i < videoPlayerIDs.length; i++) {
        jwplayer(videoPlayerIDs[i]).stop();
      }
    }
    function playCurrentSceneFirstVideo(currentSceneEl,currenSceneGroupId){
      const currenSceneGroupEl = $(`[data-id="${currenSceneGroupId}"]`);
     const doNotAutoPlayMediaOnSceneChange = $(currenSceneGroupEl).hasClass('do-not-auto-play-media-on-scene-change-1')
     const doNotAutoPlayMediaOnFirstScene = $(currenSceneGroupEl).hasClass('do-not-auto-play-first-scene-1')
    const firstSceneID = document.querySelector('div.scene').getAttribute('data-id');
    if (doNotAutoPlayMediaOnFirstScene && currentSceneEl.attr('data-id') == firstSceneID) {
      return;
    }
      if(doNotAutoPlayMediaOnSceneChange) return;
      const jwplayers = $(currentSceneEl).find('.jwplayer');
      if(jwplayers.length){
        stopAllVideoPlayers();
        const firstPlayer = jwplayers[0];
        const videoPlayerID = $(firstPlayer).attr('id')
        if(videoPlayerID && window[videoPlayerID] ){
          window[videoPlayerID].play(true);
        }
        
      }
    }
    
  function handleMuteOnSceneChange(currentSceneEl,currenSceneGroupId){
    const currenSceneGroupEl = $(`[data-id="${currenSceneGroupId}"]`);
    const doNotAutoPlayMediaOnSceneChange = $(currenSceneGroupEl).hasClass('do-not-mute-media-on-scene-change-1')
    if(doNotAutoPlayMediaOnSceneChange) return;
    stopAllVideoPlayers();
  }

  function setupStateSubscriber() {
    if (window.hasOwnProperty('store')) {
      store.subscribe(handleSceneChange);
    } else {
      setTimeout(function () {
        setupStateSubscriber();
      }, 100);
    }
  }

  setupStateSubscriber();


  $('a[data-target="home-scene"]').click(function (e) { // Used in ipa-corp communicate with clients and collegues
    const thisSceneGroup = $(this).closest('.sceneGroup');
    const sceneToShow = thisSceneGroup.children('.scene').first();

    const sceneGroupId = thisSceneGroup.attr('data-id');
    const sceneToShowId = sceneToShow.attr('data-id');

    store.dispatch(actions.setSceneById({ sceneId: sceneToShowId, sceneGroupId }));
  });

  $('a[data-toggle="scene"]').click(function () {
    // Used in ipa-corp communicate with clients and collegues

    const target = $(this).data('target');
    store.dispatch(actions.setSceneByName(target));
  });

  // $(".scenes .scene").hide(); //this would be better to do this with CSS because it's still showing.
  // $(".scenes .scene").first().show();
  $(document).on('changeScene', function (e) {
    // TODO -  set up the advance sliders the in this scene.  ... I've tested this and this fixes the problem with.

    // console.log(window);

    // console.log(e.message);

    // stop any video that might playing
    if (window.playerloaded == 'yes') {
      jwplayer(window.playerID).stop();
      window.playerloaded == 'no';
    }


    if (e.message) {
      const target = e.message;
      // alert("." + target);
      $(`.${target} .Scenes .scene`).first().show();
      const video = $(`.${target} .videodiv`);

      //  console.log(video);
      // set the cookie for the current scene.

      Cookies.set('currentScene', target, {
        expires: 7,
        path: '/',
      });

      if (video.length > 0) {
        // alert('video exist');
        const thisPlayer = $('.jwplayer', video[0]).attr('id');

        const bandwidth = Cookies.get('bandwidth');
        // console.log(bandwidth);
        // console.log(thisPlayer);

        switch (bandwidth) {
        case 'low':
          var datarate = 'Low';
          break;
        case 'medium':
          var datarate = 'SD';
          break;
        case 'high':
          var datarate = 'HD';
          break;
        }


        jwplayer(thisPlayer).setCurrentQuality(datarate);

        // jwplayer(thisPlayer).play();
        // video.addVariable(‘autostart’,‘true’);;
      }
    }
  });


  $('.scene a[href*="#"]').click(function (e) { // add the event to href that have #
    if (!e) e = window.event;
    let specificScene = false;
    var target;
    if ($(this).attr('href')) {
      const theLink = $(this).attr('href');
      const parts = theLink.split('#');
      target = parts[1];
    } else {
      target = $(this).data('target');
    }

    if ($(this).attr('data-toggle') == 'scene') {
      target = $(this).attr('data-target');
      specificScene = true;
    }

    const thisScene = $(this).closest('.scene');
    const thisScenes = $(this).closest('.scenes');
    // console.log('setting scene to: '+target);
    // console.log(this);
    if (target == 'next') {
      e.preventDefault();
      var effect = $(e.target).closest('.scene').next('.scene').data('effect');

      if (effect == 'Fade') {
        $(e.target).closest('.scene').next('.scene').fadeToggle('slow', 'linear');


        $(e.target).closest('.scene').fadeToggle('slow', 'linear', function () {
          // console.log($(this));
          const linkspanid = $(this).data('navlink');
          const navbarid = $(`#${linkspanid}`).data('indicatorid');
          $('.indicator').html('');
          $(`#${navbarid}`).html('<img src="/themes/aec-po/images/radio-selected.png" alt="selected">');
        });
      } else {
        $(e.target).closest('.scene').next('.scene').css('display', function () {
          // console.log($(this));
          const linkspanid = $(this).data('navlink');
          const navbarid = $(`#${linkspanid}`).data('indicatorid');
          $('.indicator').html('');
          // $('#' + navbarid).html('<img src="/themes/aec-po/images/radio-selected.png" alt="selected">');
          return 'block';
        });

        // alert('turning the current one of');
        $(e.target).closest('.scene').css('display', 'none');
      }


      var target = $(e.target).closest('.scene').next('.scene').data('scene');

      $.event.trigger({
        type: 'changeScene',
        message: target,
        time: new Date(),
      });


      Cookies.set(currentCookie, target, {
        expires: 30,
      });
    } else if (target == 'previous') {
      e.preventDefault();
      var effect = $(e.target).closest('.scene').prev('.scene').data('effect');

      if (effect == 'Fade') {
        $(e.target).closest('.scene').prev('.scene').fadeToggle('slow', 'linear', function () {
          // console.log($(this));
          const linkspanid = $(this).data('navlink');
          // console.log('linkspanid '+linkspanid);
          const navbarid = $(`#${linkspanid}`).data('indicatorid');
          $('.indicator').html('');
          $(`#${navbarid}`).html('<img src="/themes/aec-po/images/radio-selected.png" alt="selected">');
        });

        $(e.target).closest('.scene').fadeToggle('slow', 'linear');
      } else {
        $(e.target).closest('.scene').prev('.scene').css('display', function () {
          // console.log($(this));
          // alert('here');
          const linkspanid = $(this).data('navlink');
          // console.log('linkspanid2 '+linkspanid);
          const navbarid = $(`#${linkspanid}`).data('indicatorid');
          $('.indicator').html('');
          $(`#${navbarid}`).html('<img src="/themes/aec-po/images/radio-selected.png" alt="selected">');
          return 'block';
        });

        $(e.target).closest('.scene').css('display', 'none');
      }

      var target = $(e.target).closest('.scene').prev('.scene').data('scene');
      $.event.trigger({
        type: 'changeScene',
        message: target,
        time: new Date(),
      });

      Cookies.set(currentCookie, target, {
        expires: 30,
      });
    } else if (target !== '' && target == '1') {
      if (!$(target).isVisible()) {
        // and show the section that has this scene
        $(`.${target}`).closest('.scenepage').show();
      }
      // check for target, if there's none let other anchor tags get processed e.g. tooltips
      // if there is one, jump to the target.

      // hide all rpl page sections
      $('.scenepage').hide();
      // and show the section that has this scene
      $(`.${target}`).closest('.scenepage').show();

      if (effect == 'Fade') {
        $(`.scenes .${target}`).fadeToggle('slow', 'linear');
        $(e.target).closest('.scene').fadeToggle('slow', 'linear', function () {
          // console.log($(this));
          const linkspanid = $(this).data('navlink');
          // console.log('linkspanid '+linkspanid);
          const navbarid = $(`#${linkspanid}`).data('indicatorid');
          $('.indicator').html('');
          // $('#' + navbarid).html('<img src="/themes/aec-po/images/radio-selected.png" alt="selected">');
        });
      } else {
        $(`.scenes .${target}`).css('display', 'block');
        $(e.target).closest('.scene').css('display', function () {
          // console.log($(this));
          const linkspanid = $(this).data('navlink');
          // console.log('linkspanid1 '+linkspanid);
          const navbarid = $(`#${linkspanid}`).data('indicatorid');
          // var navbarid = $('#sidebarlinkspan' + target).data('indicatorid');
          $('.indicator').html('');
          // $('#' + navbarid).html('<img src="/themes/aec-po/images/radio-selected.png" alt="selected">');
          return 'none';
        });

        $.event.trigger({
          type: 'changeScene',
          message: target,
          time: new Date(),
        });
      }

      Cookies.set(currentCookie, target, {
        expires: 30,
      });
    }
  });
});



// WEBPACK FOOTER //
// Glasshouse/Core/js/scenes.js